import { styled } from "styled-components";

export const RankingBoardSettingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  opacity: 0.6;
  background: #000;
`;

export const RankingBoardSettingContentWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 43px 40px 56px;
  width: 479px;
  background: #fff;
  border-radius: 13px;

  opacity: 1;
`;

export const RankingBoardSettingHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const RankingBoardSettingTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const RankingBoardSettingCloseButton = styled.img`
  cursor: pointer;
`;

export const RankingBoardSettingBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 52px;
  gap: 20px;
`;

export const RankingBoardSettingPageText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  align-items: center;
  color: #121212;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const RankingBoardSaveButton = styled.div`
  margin-top: 30px;
  width: 100%;
  height: 59px;
  border-radius: 20px;
  background: #6436e7;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 20.233px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const EditBaseItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  > .title {
    display: flex;
    align-items: center;
    width: 169.287px;
    color: #1a191a;
    font-family: Pretendard;
    font-size: 20.233px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .check {
    > input[type="checkbox"] {
      width: 22px;
      height: 22px;
      border: 2px solid #d9d9d9;
      background-color: #fff;
      vertical-align: bottom;
      cursor: pointer;
      margin: 0;
      border: 1.3px solid #d9d9d9;
    }
  }
`;

export const EditBaseDropBox = styled.div`
  width: 320.896px;
  height: 24.727px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .value {
    color: #121212;
    font-family: Pretendard;
    font-size: 10.791px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const EditBaseDropBoxItemWrapper = styled.div`
  background-color: #fff;
  width: 338px;
  z-index: 1001;
  top: 44px;
  left: -1px;
  position: absolute;
  border-radius: 2.7px;
  border: 1px solid var(--Black-200, #b7b7b7);
  display: flex;
  flex-direction: column;
`;

export const EditBaseDropBoxItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 14.196px;
    height: 14.196px;
    margin-right: 5px;
  }
  > span {
    padding: 5.396px 8.093px;
    color: #121212;
    font-family: Pretendard;
    font-size: 10.791px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const EditBaseInputBox = styled.div<{ type?: string }>`
  cursor: pointer;
  width: 320.896px;
  height: 24.727px;
  padding: 5.396px 8.093px;
  border-radius: 2.698px;
  border: 0.674px solid var(--Black-200, #b7b7b7);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: ${(p) =>
    p.type === "back" ? "var(--Black-100, #f0f0f0)" : "#fff"};

  > span {
    color: #808080;
    font-family: Pretendard;
    font-size: 10.791px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > input {
    outline: none;
    border: none;
    padding: 0px;
    width: 320.896px;
    height: 24.727px;

    ${(p) =>
      p.type === "entry"
        ? `flex: 1;
      margin-right: 10px;`
        : ""}
  }

  > input[type="date"],
  input[type="time"] {
    color: #121212;
    font-family: Pretendard;
    font-size: 10.791px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > input::placeholder {
    font-size: 11px;
  }
`;

export const EditEntryCheckbox = styled.div`
  position: relative;

  > img {
    position: absolute;
    top: 7px;
    left: 5px;
    pointer-events: none;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 22px;
    height: 22px;
    border: 2px solid #d9d9d9;
    background-color: #fff;
    vertical-align: bottom;
    cursor: pointer;
    margin: 0;
    border: 1.3px solid #d9d9d9;
  }

  input[type="checkbox"]:checked {
    border: 1px solid #d9d9d9;
    background-color: #7f25fb;
  }
`;
